/**
  配置管理--设备快速查询--配置信息
 */
import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Input, Spin } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { hpcStubCfgSave, hpcStubCfgInfo } from "../../../fetch/fetchApi";

const FormItem = Form.Item;
const { TextArea } = Input;
// eslint-disable-next-line arrow-parens
@connect(state => state)
class HpcSettingModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      jsonI:null,
      internationalization: this.props.intl.messages.stubStatusUpdate,
    };
  }

  componentWillMount() {
    
    this.getHPCStubSetting();
    // this.getFrameWork();
  }

  getHPCStubSetting() {
    this.setState({
      spinning: false,
      seconds: 11,
    });

    fetchHandler(hpcStubCfgInfo, {
      stubId:this.props.stubId
    }).then((res) => {
      if (res && (res.code === "ok" || res.code === "success")) {
      
      var oldWord = JSON.stringify(JSON.parse(res.data));
      this.props.form.setFieldsValue({
        // settingJson: JSON.stringify(JSON.parse(wq), null, 2)
        settingJson: JSON.stringify(JSON.parse(res.data), null, 2)
      });
      this.setState({
        oldWord:oldWord,
      });
    }
    this.setState({
      spinning: false,
    });
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        values.stubId = this.props.stubId;
        let data = null;
        try {
          data = JSON.parse(values.settingJson);
        } catch (e) {
            
        }
        if (data == null)
        {

          message.error("配置信息不是json格式，请检查。");
          return;
        }
        this.setState({
          btnLoading: true,
        });
        
        values.settingJson = JSON.stringify(data)
        values.old = this.state.oldWord;
        fetchHandler(hpcStubCfgSave, {
          ...values,
        }).then((res) => {
          // if (this.props.setSelectedRowKeysNull) {
          //   this.props.setSelectedRowKeysNull();
          // }
          if (res && (res.code === "ok" || res.code === "success")) {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
        <Spin spinning={this.state.spinning}>
          <FormItem  label={'配置内容'}>
            {getFieldDecorator("settingJson", {
              rules: [
                {
                  required: true,
                  message: '请填写配置内容', // "请填写配置内容"
                },
              ],
            })(
              <TextArea rows={20} />,
              )}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
          </Spin>
        </Form>
      </div>
    );
  }
}

const HpcSettingModalS = Form.create()(HpcSettingModal);

export default injectIntl(HpcSettingModalS);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/hpcSettingModal.js